<div class="auth--card">
  <ng-content select="[authCard]"></ng-content>
</div>

<div class="auth-banner__hero">
  <img
    [src]="layoutOptions.heroImg"
    alt="Authentication Banner Hero"
    data-test-id="authBannerHeroImage"
  />
</div>

<div class="ImageTextSeparator"></div>

<div class="MoreInfo">
  <div class="MoreInfo__Header">
    @if (layoutOptions?.header?.icon) {
      <img
        [src]="layoutOptions?.header?.icon"
        alt="Header Icon"
        data-test-id="headerIconImage"
      />
    } @else {
      <icon
        data-test-id="moreInfoHeaderIcon"
        class="MoreInfo__HeaderIcon"
        [config]="{ size: 'large', fill: 'primary' }"
        [name]="layoutOptions?.header?.iconName || 'cover_who'"
      ></icon>
    }
    <h3
      class="t-bold"
      [innerHTML]="layoutOptions?.header?.text"
      data-test-id="authBannerHeader"
    ></h3>
  </div>

  <div class="sections">
    @for (section of layoutOptions?.sections; track section; let i = $index) {
      <div class="section">
        <h4 class="t-bold" [attr.data-test-id]="'authBannerTitle-' + i">
          {{ section?.title }}
        </h4>
        <div class="underline"></div>
        @if (section.type === 'text') {
          <div class="section--text">
            <p
              class="t-data"
              data-test-id="'authBannerSectionText-' + i"
              [innerHTML]="section?.text"
            ></p>
          </div>
        }
        @if (section?.type === 'list') {
          <div class="section--list">
            @for (item of section.list; track item; let i = $index) {
              <div class="list--item">
                <i
                  class="icon icon--medium"
                  [attr.data-test-id]="'listItemIcon-' + i"
                >
                  {{ item.icon || 'check' }}
                </i>
                <p
                  class="t-data"
                  [attr.data-test-id]="'listItemText-' + i"
                  [innerHTML]="item?.text"
                ></p>
              </div>
            }
          </div>
        }
        @if (section.type === 'links') {
          <div class="section--links">
            @if (section?.description) {
              <p
                class="t-data"
                data-test-id="authBannerSectionDescription"
                [innerHTML]="section?.description"
              ></p>
            }
            @for (link of section?.links; track link; let i = $index) {
              <a
                target="_blank"
                class="t-data t-link"
                [href]="link.url"
                data-test-id="authBannerSectionLink"
              >
                {{ link.label }}
                <i
                  class="icon icon--small icon--link"
                  data-test-id="'authBannerLinkIcon-' + i"
                >
                  {{ link.icon || 'chevron_right' }}
                </i>
              </a>
            }
          </div>
        }
        @if (section?.button) {
          <zip-button
            [config]="section?.button"
            data-test-id="authBannerMoreInfoButton"
          ></zip-button>
        }
      </div>
    }
  </div>
</div>
